import { viewportHeightUI } from "../App";
import useUIBp from "./useUIBoilerplate";

const useVH = (x) => {
    const {UI} = useUIBp()
    const height = UI[viewportHeightUI]
    return `${height * x/100}px`
}

export default useVH;